<template>
  <div class="page">
    <FriedCard class="template-page">
      <VideoPage v-if="isPageType(DocumentPageType.Video)" :page="page" />
      <ContentLinkPage
        v-else-if="isPageType(DocumentPageType.ContentLink)"
        :content-link-block="page.contentLinkBlock"
      />
      <PDFPage
        v-else-if="isPageType(DocumentPageType.DocumentContent)"
        class="pdf-page"
        :page="page"
        :page-width="pageWidth"
        :recipients="[]"
      />
      <div v-else-if="isPageType(DocumentPageType.Editor)" class="editor-wrapper">
        <EditorBlockView
          :content="editorContent"
          :context="Context.DocumentView"
          :all-content="allContent"
        />
      </div>
    </FriedCard>
  </div>
</template>

<script lang="ts" setup>
import { EditorBlockView } from '@getaccept/editor-view';
import { Context } from '@getaccept/editor-lib';
import type {
  DocumentEditorPage,
  DocumentPage,
} from '@getaccept/lib-shared/src/types/document-page';
import { DocumentPageType } from '@getaccept/lib-shared/src/enums/document-page-type';
import { computed } from 'vue';
import ContentLinkPage from '@getaccept/lib-shared/src/components/ContentLinkPage.vue';
import VideoPage from '@getaccept/lib-shared/src/components/VideoPage.vue';
import PDFPage from '@getaccept/lib-shared/src/document-view/components/PDFPage.vue';

const props = defineProps<{ page: DocumentPage; pages: DocumentPage[]; pageWidth: number }>();
const editorContent = computed(() => props.page?.editorBlock?.content);

const isPageType = (pageType: DocumentPageType) => props.page.pageType === pageType;

const isEditorPage = (page: DocumentPage): page is DocumentEditorPage =>
  !!page.editorBlock && page.pageType === DocumentPageType.Editor;

const allContent = computed(() => {
  const pageWithEditorContent = props.pages.filter(isEditorPage);
  return pageWithEditorContent.map(page => page.editorBlock.content);
});
</script>

<style scoped>
.page {
  position: relative;

  .template-page {
    .editor-wrapper {
      position: relative;
    }

    .pdf-page {
      overflow: hidden;
      border-radius: var(--radius-medium);
    }
  }
}
</style>
